'use client';

import { EmbedField, ImageField, isFilled } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import clsx from 'clsx';
import Image from 'next/image';
import { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

import { IconPlay } from '@/app/_componentsv2/icons/play';

import {
  iframe,
  modal,
  overlay,
  trigger,
  triggerIcon,
  triggerImg,
  triggerImg2,
  wrapper,
  wrapper2,
} from './video-player.css';

type VideoPlayerProps = {
  classNames?: {
    wrapper?: string;
  };
} & PrismicVideoPlayerProps;

type PrismicVideoPlayerProps = {
  field: EmbedField;
  image: ImageField;
  hasHeightAuto?: boolean;
};

export function VideoPlayer({
  field,
  image,
  classNames,
  hasHeightAuto,
}: VideoPlayerProps) {
  const [open, setOpen] = useState(false);

  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (document === undefined) {
      return setUrl('');
    }

    const el = document.createElement('div');
    el.innerHTML = field.html ?? '';
    setUrl(
      new URL(
        el.getElementsByTagName('iframe')[0].attributes.getNamedItem('src')
          ?.value ?? '',
      ).href,
    );
  }, [field]);

  return (
    <section
      data-page-locked={open || undefined}
      className={clsx(hasHeightAuto ? wrapper2 : wrapper, classNames?.wrapper)}
    >
      <a
        className={trigger}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {isFilled.image(image) ? (
          <PrismicNextImage
            fallbackAlt=""
            className={hasHeightAuto ? triggerImg2 : triggerImg}
            field={image}
          />
        ) : (
          <Image
            className={hasHeightAuto ? triggerImg2 : triggerImg}
            alt={field.title ?? ''}
            src={field.thumbnail_url ?? ''}
            width={field.thumbnail_width ?? 960}
            height={field.thumbnail_height ?? 960}
          />
        )}
        <IconPlay className={triggerIcon} />
      </a>
      {open &&
        createPortal(
          <section className={overlay} onClick={() => setOpen(false)}>
            <section className={modal}>
              <iframe
                className={iframe}
                width={'100%'}
                height={'100%'}
                src={`${url}&autoplay=1`}
                allow="autoplay"
                frameBorder={0}
              ></iframe>
            </section>
          </section>,
          document.body,
        )}
    </section>
  );
}
